import React, { Suspense, lazy } from 'react';
import "./App.css";
import { Route, Routes } from "react-router-dom";

const LandingPage = lazy(() => import("./pages/landing.page"));
const Login = lazy(() => import("./pages/login.page").then(module => ({ default: module.Login })));
const LoginRedirect = lazy(() => import("./pages/login.page").then(module => ({ default: module.LoginRedirect })));
const MapSelectionPage = lazy(() => import("./pages/mapSelection.page"));
const FormPage = lazy(() => import("./pages/form.page").then(module => ({ default: module.FormPage })));
const TermsAndConditionsPage = lazy(() => import("./pages/termsAndConditions.page"));
const ErrorPage = lazy(() => import("./pages/error.page").then(module => ({ default: module.ErrorPage })));

const AppContent = () => {
  return (
    <Suspense fallback={<output className="app__loading" aria-live="polite">Loading…</output>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/redirect" element={<LoginRedirect />} />
        <Route path="/utilitySelect" element={<MapSelectionPage />} />
        <Route path="/form" element={<FormPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
};

function App() {
  return (
      <div className='app' data-testid="app-component">
        <AppContent />
      </div>
  );
}

export default App;
